export class DefaultAviaConstants {
    static _instance = new DefaultAviaConstants();
    constructor() {
        if (DefaultAviaConstants._instance) {
            throw new Error(this.name +
                ' is a Singleton and can only be accessed through ' +
                this.name +
                '.getInstance()');
        }
        DefaultAviaConstants._instance = this;
    }
    static getInstance() {
        return DefaultAviaConstants._instance;
    }
    get name() {
        return 'DefaultAviaConstants';
    }
    get overrides() {
        return {
            minDvrDuration: 600
        };
    }
    get startBitrate() {
        return 250000;
    }
    get maxBitrate() {
        return NaN;
    }
}
